import React, { useState, useEffect, useCallback} from "react";
import {
  TextField,
  Button,
  ChoiceList,
  Filters,
  Icon,
  InlineStack,
  ButtonGroup,
  Box,
} from "@shopify/polaris";
import intl from "../../../../../i18n/intl";
import {
  SearchMinor,
} from '@shopify/polaris-icons'
import DatePicker from "react-datepicker";
const Search = ({ data, onSearch,selected ,setSearchParam}) => {
  const [queryValue, setQueryValue] = useState("");
  const [selectPublish, setSelectPublish] = useState(
    data?.searchParam?.selectPublish
  );
  const [searchButton, setSearchButton] = useState({
    isDisableSearch: true,
    isDisableClear: true,
    isSearching: "0",
  });
  
  const [selectProductStatus, setSelectProductStatus] = useState(
    data?.searchParam?.selectProductStatus
  );

  useEffect(() => {
    setSelectPublish(data?.searchParam?.selectPublish);
    setQueryValue(data?.searchParam?.q)
    setSelectProductStatus(data?.searchParam?.selectProductStatus)
  }, [data]);

  const handleSearch = () => {
    onSearch(
      {
        q: queryValue,
      }
    );
    setSearchButton((prevValue) => ({
      ...prevValue,
      isSearching: "1",
    }));
    setTimeout(() => {
      setSearchButton((prevValue) => ({
        ...prevValue,
        isSearching: 0,
      }));
    }, 1500);
  };
 

  // 输入框搜索
  const changeInput = (value) => {
    setQueryValue(value);
    setSearchButton((prevValue) => ({
      ...prevValue,
      isDisableSearch: false,
      isDisableClear: false,
    }));  
    if (!value) {
      onSearch(
        {
          q: value,
        }
      );
    }
  };

  // 清空输入框
  const clearText = useCallback(() => {
    setQueryValue("");
    setSearchParam((prevValue) => ({
      ...prevValue,
      start_date:'',
      end_date:''
    }));
    setSearchButton((prevValue) => ({
      ...prevValue,
      isDisableSearch: true,
      isDisableClear: true,
      isSearching: 0,
    }));  
    handleSearch();
    
    // eslint-disable-next-line
  }, []);

  // 状态筛选
  const changeStatus = (val, type) => {
    if ( type === "Import status") {
      setSelectPublish(val) 
      setSelectProductStatus(null)
    }else{
      setSelectProductStatus(val)
    }
    onSearch(
      type === "Import status"
        ? {
            selectPublish: val,
          }
        : {
            selectProductStatus: val,
          }
    );
    // eslint-disable-next-line
  };

  // 清除状态
  const clearStatus = useCallback((type) => {
    if (type === "selectProductStatus") {
      onSearch({
        selectProductStatus: [],
      });
      setSelectProductStatus(null);
    }else {
      onSearch({
        selectPublish: ['Not imported'],
      });
    }
    // eslint-disable-next-line
  }, []);

 
   // 搜索时间
   const changeSearchDate = (type, date) => {
    let no_allow_search = true;

    switch (type) {
      case "start":
        setSearchParam((prevValue) => ({
          ...prevValue,
          start_date: date,
        }));
        if (data?.searchParam.end_date !== "") {
          // if (!dayjs(date).isSameOrBefore(dayjs(this.state.end))) {
          //   this.toggleToast('Start time should be less than the end time', true);
          //   return;
          // }
          no_allow_search = false;
        }
        break;

      case "end":
        setSearchParam((prevValue) => ({
          ...prevValue,
          end_date: date,
        }));
        // 判断结束时间不能小于开始时间
        if (data?.searchParam.start_date !== "") {
          // if (!dayjs(this.state.start).isSameOrBefore(dayjs(date))) {
          //   this.toggleToast('End time should be greater than the start time', true);
          //   return;
          // }
          no_allow_search = false;
        }

        break;
      default:
    }

    if (data?.searchParam.query !== "") {
      no_allow_search = false;
    }

    setSearchButton((prevValue) => ({
      ...prevValue,
      isDisableSearch: no_allow_search,
      isDisableClear: false,
    }));
  };

  

  const filters = [
    // {
    //   key: "selectPublish",
    //   label: intl.get("List status"),
    //   filter: (
    //     <ChoiceList
    //       title={intl.get("List status")}
    //       titleHidden
    //       choices={importChoice}
    //       selected={selectPublish || []}
    //       onChange={(val) => changeStatus(val, "Import status")}
    //     />
    //   ),
    //   shortcut: true,
    //   hideClearButton: true,
    // },
    {
      key: "selectProductStatus",
      label: intl.get("Product status"),
      filter: (
        <ChoiceList
          title={intl.get("Product status")}
          titleHidden
          choices={[
            { label: intl.get("For Sale"), value: "For Sale" },
            { label: intl.get("Offline"), value: "Offline" },
          ]}
          selected={selectProductStatus || []}
          onChange={(val) => changeStatus(val, "Product status")}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(selectPublish)) {
    const key = "selectPublish";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, selectPublish),
      onRemove: () => clearStatus("selectPublish"),
    });
  }
  if (!isEmpty(selectProductStatus)) {
    const key = "selectProductStatus";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, selectProductStatus),
      onRemove: () => clearStatus("selectProductStatus"),
    });
  }
  const handleFiltersClearAll = () => {
    if (selectProductStatus.length > 0) {
      clearStatus("selectProductStatus")
    }
  };

  return (
    <div className="Search product_search" style={{minHeight:'70px',paddingTop:8}}>
      <InlineStack algin='space-between'>
          <TextField
            labelHidden
            prefix={<Icon source={SearchMinor} />}
            value={queryValue}
            placeholder={intl.get("Filter products")}
            onChange={changeInput}
            clearButton
            onClearButtonClick={clearText}
            autoComplete="off"
            maxLength={500}
          />
          {/* 时间搜索框 */}
          {(selected === 0 || selected ===1) && <Box style={{display:'flex',flexWrap:"wrap"}}>
          <div className="dateSearchArea search_item">
                          <div className="Polaris-TextField startDateInput">
                            <DatePicker
                              placeholderText="Start"
                              selectsStart
                              startDate={data?.searchParam.start_date}
                              endDate={data?.searchParam.end_date}
                              maxDate={data?.searchParam.end_date}
                              selected={data?.searchParam.start_date}
                              onChange={(date) =>
                                changeSearchDate("start", date)
                              }
                              className="Polaris-TextField__Input"
                            />
                          </div>
                          <div className="timearrow">
                            <img src="/timearrow.png" alt="" />
                          </div>
                          <div className="Polaris-TextField endDateInput">
                            <DatePicker
                              placeholderText="End"
                              selectsEnd
                              startDate={data?.searchParam.start_date}
                              endDate={data?.searchParam.end_date}
                              minDate={data?.searchParam.start_date}
                              selected={data?.searchParam.end_date}
                              onChange={(date) => changeSearchDate("end", date)}
                              className="Polaris-TextField__Input"
                            />
                          </div>
                        </div>

                        {/* 搜索按钮组 */}
                        <div className="search_btnGroup search_item">
                          <ButtonGroup>
                            <Button
                              variant="primary"
                              onClick={()=>{handleSearch()}}
                              disabled={searchButton.isDisableSearch}
                              loading={searchButton.isSearching === "1"}
                            >
                            {intl.get("Search")}
                            </Button>
                            <Button
                              onClick={()=>{clearText()}}
                              disabled={searchButton.isDisableClear}
                            >
                              {intl.get("Clear")}
                            </Button>
                          </ButtonGroup>
                        </div>
                        </Box>}
          {(selected > 1) && <Button variant="primary" onClick={handleSearch}>
            {intl.get("Find products")}
          </Button>}
      </InlineStack>
      <Filters
        hideQueryField
        filters={filters}
        appliedFilters={appliedFilters}
        onClearAll={handleFiltersClearAll}
      />
        
    </div>
  );

  function disambiguateLabel(key, value) {
    if (value && value[0].indexOf('Not imported') !== -1) {
      value = ['Not Listed']
    }
    if (value && value[0].indexOf('Imported') !== -1) {
      value = ['Listed']
    }
    switch (key) {
      case "selectPublish":
        return value.map((val) => val);
      case "selectProductStatus":
        return value.map((val) => val);
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Search;
